import RenderIf from "common/components/RenderIf";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

export default function LtdSeats() {
  const { lifetime_license_count: lifetimeLicenseCount } =
    useSelectedWorkspaceContext();

  return (
    <RenderIf condition={lifetimeLicenseCount > 0}>
      <div className="flex items-center justify-between px-2 py-1">
        <span className="text-button-sm text-black-600">Lifetime seats</span>
        <span className="text-md-medium text-black-500">
          {lifetimeLicenseCount}
        </span>
      </div>
    </RenderIf>
  );
}
